// https://vuex.vuejs.org/en/state.html

const state = {
  profile: {},
  api: {
    token: null
  },
  version: {},
  product: {}
};

export default state;
